import React from 'react';
import { 
  HeroSection, 
  WhatIsEclipseDriveSection,
  ParticipationFormatSection,
  CashbackSection,
  EKISection,
  // LicensesSection,
  PrizePoolSection,
  AmbassadorSection,
  FinalEventSection,
} from 'containers';
import { decoreShapesHeroIcon } from 'assets/images';
import styles from './styles.module.scss';

export const EclipseDrivePage = () => {
  const { pathname } = window.location;
  const isAuthenticated: boolean = pathname.includes('/cabinet'); 

  return (
    <div className={`${styles.eclipse_drive_page} ${
      isAuthenticated ? '' : styles.eclipse_drive_page_authenticated
    }`}
    >
      <div className={styles.eclipse_drive_container}>
        <img
          src={decoreShapesHeroIcon}
          alt=""
          className={styles.decor_shapes}
        />
        <HeroSection isAuthenticated={isAuthenticated} />
        <WhatIsEclipseDriveSection />
        <ParticipationFormatSection isAuthenticated={isAuthenticated} />
        <CashbackSection />
        <EKISection isAuthenticated={isAuthenticated} />
        {/* <LicensesSection isAuthenticated={isAuthenticated} /> */}
        <PrizePoolSection isAuthenticated={isAuthenticated} />
        <AmbassadorSection />
        <FinalEventSection isAuthenticated={isAuthenticated} />
      </div>
    </div>
  );
};
